import { DpContainer } from '@/components/blocks/DpContainer';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';
import { Box, Stack, SxProps, Typography } from '@mui/material';

interface DpSitemapContainerProps {
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpSitemapContainer = ({ children, sx, ...props }: DpSitemapContainerProps) => (
	<DpContainer
		sx={combineSX([
			{ marginTop: 'var(--spacing-8)', marginBottom: '120px' },
			Array.isArray(sx) ? sx : [sx],
		])}
		{...props}
	>
		{children}
	</DpContainer>
);

interface DpSiteMapTitleProps {
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpSiteMapTitle = ({ children, sx, ...props }: DpSiteMapTitleProps) => (
	<Typography
		component="h1"
		sx={combineSX([
			{ fontWeight: 800, fontSize: 'var(--font-size-xl)', mb: '30px', textTransform: 'uppercase' },
			Array.isArray(sx) ? sx : [sx],
		])}
		{...props}
	>
		{children}
	</Typography>
);

interface DpSiteMapContainerProps {
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpSiteMapContent = ({ children, sx, ...props }: DpSiteMapContainerProps) => (
	<Box
		sx={combineSX([
			{ display: 'flex', flexWrap: 'wrap', gap: { xs: '30px', sm: '41px', lg: '81px' } },
			Array.isArray(sx) ? sx : [sx],
		])}
		{...props}
	>
		{children}
	</Box>
);

interface DpSiteMapLinkLinkFrameProps {
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpSiteMapLinkLinkFrame = ({ children, sx, ...props }: DpSiteMapLinkLinkFrameProps) => (
	<Stack
		sx={combineSX([{ width: { xs: '45%', sm: 'auto' } }, Array.isArray(sx) ? sx : [sx]])}
		{...props}
	>
		{children}
	</Stack>
);

interface DpSiteMapLinkProps {
	href: string;
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpSiteMapLink = ({ href, children, sx, ...props }: DpSiteMapLinkProps) => (
	<Linkable
		variant="secondary"
		href={href}
		sx={combineSX([
			{
				fontSize: 'var(--font-size-sm)',
				textTransform: 'uppercase',
				fontWeight: 'bold',
				pb: { xs: '10px', sm: '17px' },
			},
			Array.isArray(sx) ? sx : [sx],
		])}
		{...props}
	>
		{children}
	</Linkable>
);

export const DpSiteMapLinkOutOfFocus = ({ href, children, sx, ...props }: DpSiteMapLinkProps) => (
	<Linkable
		variant="secondary"
		href={href}
		sx={combineSX([
			{ fontSize: 'var(--font-size-default)', pb: '10px' },
			Array.isArray(sx) ? sx : [sx],
		])}
		{...props}
	>
		{children}
	</Linkable>
);

interface DpSiteMapLinkOutOfFocusTitleProps {
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpSiteMapLinkOutOfFocusTitle = ({
	children,
	sx,
	...props
}: DpSiteMapLinkOutOfFocusTitleProps) => (
	<Typography
		component="h3"
		sx={combineSX([
			{
				fontSize: '16px',
				textTransform: 'uppercase',
				fontWeight: 'bold',
				pb: { xs: '10px', sm: '9px' },
			},
			Array.isArray(sx) ? sx : [sx],
		])}
		{...props}
	>
		{children}
	</Typography>
);
